import { Tag } from "../service/tagService";
import { Button } from "@/shared/ui/button";
import { Edit } from "lucide-react";
import { Badge } from "@/shared/ui/badge";
import { DataTable } from "@/shared/widgets";

interface TagsTableProps {
    tags: Tag[];
    isLoading: boolean;
    onEdit: (tag: Tag) => void;
}

export function TagsTable({ tags, isLoading, onEdit }: TagsTableProps) {
    return (
        <DataTable
            data={tags}
            isLoading={isLoading}
            emptyTitle="Nenhuma tag encontrada"
            emptyDescription={() => "Comece criando uma nova tag"}
            columns={[
                {
                    header: "Nome",
                    cell: (tag) => {
                        const ptBrName = tag.translations.find(t => t.languageCode === 'PT_BR')?.name || 'Sem nome';
                        return <span className="text-white">{ptBrName}</span>;
                    },
                },
                {
                    header: "Status",
                    cell: (tag) => (
                        <Badge variant={tag.published ? 'default' : 'secondary'}>
                            {tag.published ? 'Publicado' : 'Rascunho'}
                        </Badge>
                    ),
                },
                {
                    header: "Tipo",
                    cell: (tag) => (
                        <span className="text-white/60">
                            {tag.isCategory ? 'Categoria' : 'Tag'}
                        </span>
                    ),

                },
                {
                    header: "Ações",
                    cell: (tag) => (
                        <div className="flex justify-end gap-2">
                            <Button
                                variant="ghost"
                                size="icon"
                                onClick={() => onEdit(tag)}
                                title="Editar"
                            >
                                <Edit className="h-4 w-4" />
                            </Button>
                        </div>
                    ),
                    className: "text-right w-[100px]",
                },
            ]}
        />
    );
}